export default __webpack_public_path__ + "images/onboarding/jalebi-15a15c3fd7e104645fdb74366a124261.svg";